import styled from '@emotion/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';

import { setshow } from '../../utils/dateformat';
import ScoreTable from './scoretable';

const Container = styled.div`
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  padding: 20px 0 10px 0;
  margin-bottom: 24px;

  .MuiPaper-root {
    background: transparent;
    box-shadow: none;
  }

  .MuiAccordion-root {
    margin: 0 0 14px 0;
    border-radius: 14px !important;
    overflow: hidden;
    border: 1px solid #ffe0cc;
    background: #fff7f2;
    transition: all 0.3s ease;
  }

  .MuiAccordion-root.expanded {
    background: #ffffff;
    border: 2px solid var(--green);
    box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  }

  .MuiAccordionSummary-root {
    cursor: pointer;
    padding: 0 20px;
  }

  .MuiCollapse-root {
    overflow: auto !important;
  }
`;

const MatchData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Code = styled.div`
  font-weight: 700;
  text-transform: uppercase;
  font-size: 16px;
  color: var(--green);
  letter-spacing: 0.5px;
`;

const Overs = styled.span`
  font-size: 12px;
  color: #777;
  margin-right: 6px;
`;

const Scores = styled.div`
  font-weight: 700;
  display: flex;
  align-items: center;
  font-size: 16px;
  background: #fff3e6;
  border-radius: 10px;
  padding: 6px 14px;
  min-width: 110px;
  justify-content: flex-end;
`;

const NotStarted = styled.h3`
  color: var(--red);
  background: #fff3f3;
  padding: 24px 10px;
  text-align: center;
  border-radius: 12px;
  margin-top: 24px;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid #ffd6d6;
`;

export function ScoreCard({ data, g, livescore }) {

  const [expanded, setExpanded] = React.useState('panel2');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container>
      {data?.titleFI ? (
        <>
          {/* FIRST INNINGS */}
          <Accordion
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')}
            className={expanded === 'panel1' ? 'expanded' : ''}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: "var(--green)" }} />}
            >
              <MatchData>
                <Code>{data?.titleFI}</Code>
                <Scores>
                  <Overs>{`(${data?.oversFI} overs)`}</Overs>
                  {`${data.runFI}/${data.wicketsFI}`}
                </Scores>
              </MatchData>
            </AccordionSummary>

            <AccordionDetails>
              {data.isHomeFirst ? (
                <>
                  <ScoreTable rows={data.teamHomePlayers} batsmen />
                  <ScoreTable rows={data.teamAwayPlayers} bowlers />
                </>
              ) : (
                <>
                  <ScoreTable rows={data.teamAwayPlayers} batsmen />
                  <ScoreTable rows={data.teamHomePlayers} bowlers />
                </>
              )}
              <ScoreTable wicketsData={data.wicketsDataFI} />
            </AccordionDetails>
          </Accordion>

          {/* SECOND INNINGS */}
          <Accordion
            expanded={expanded === 'panel2'}
            onChange={handleChange('panel2')}
            className={expanded === 'panel2' ? 'expanded' : ''}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: "var(--green)" }} />}
            >
              <MatchData>
                <Code>{data?.titleSI}</Code>
                <Scores>
                  <Overs>{`(${data?.oversSI} overs)`}</Overs>
                  {`${data.runSI}/${data.wicketsSI}`}
                </Scores>
              </MatchData>
            </AccordionSummary>

            <AccordionDetails>
              {!data.isHomeFirst ? (
                <>
                  <ScoreTable rows={data.teamHomePlayers} batsmen />
                  <ScoreTable wicketsData={data.wicketsDataSI} />
                  <ScoreTable rows={data.teamAwayPlayers} bowlers />
                </>
              ) : (
                <>
                  <ScoreTable rows={data.teamAwayPlayers} batsmen />
                  <ScoreTable wicketsData={data.wicketsDataSI} />
                  <ScoreTable rows={data.teamHomePlayers} bowlers />
                </>
              )}
            </AccordionDetails>
          </Accordion>
        </>
      ) : (
        <NotStarted>Match not started yet</NotStarted>
      )}
    </Container>
  );
}

export default ScoreCard;
